import Button from 'components/atoms/students/Button';
import ModalTextContainer from 'components/molecules/students/ModalTextContainer';
import React from 'react';
import styled from '@emotion/styled';
import { isTeachers } from 'utils/checkUrl';
import { isAndroid } from 'utils/isWebView';
export default (props) => {
    const {} = props;
    const header = isAndroid()
        ? isTeachers()
            ? 'Sailアプリのアップデートが必要です。「Playストア」を開いて"Helte Sail"で検索し、Sailアプリを選んでから更新してください。'
            : 'Sailアプリのアップデートが必要です。「Playストア」を開いて"Helte Sail"で検索し、Sailアプリを選んでから更新してください。(A new version of Sail is required. Open the Play Store and search for the app ("Helte Sail"). Then, update Sail.)'
        : isTeachers()
            ? 'Sailアプリのアップデートが必要です。App Storeを開いて"Helte Sail"で検索し、Sailアプリを選んでから更新してください。'
            : 'Sailアプリのアップデートが必要です。App Storeを開いて"Helte Sail"で検索し、Sailアプリを選んでから更新してください。(A new version of Sail is required. Open the App Store and search for the app ("Helte Sail"). Then, update Sail.)';
    const storeLink = isAndroid()
        ? 'https://play.google.com/store/apps/details?id=jp.helte.android.sail'
        : 'https://apps.apple.com/us/app/sail-japanese-conversations/id1434041945';
    return (React.createElement(Container, null,
        React.createElement(ModalTextContainer, { heading: header }),
        React.createElement(ButtonContainer, null,
            React.createElement(StyledButton, { type: "blue", onClick: () => (window.location.href = storeLink) }, isTeachers() ? '更新する' : 'Update'),
            React.createElement(StyledButton, { type: "white", onClick: () => window.location.reload() }, isTeachers() ? '再読み込み' : 'Reload'))));
};
const Container = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
`;
const ButtonContainer = styled.div `
  display: flex;
  gap: 40px;
  justify-content: space-evenly;
  margin-top: auto;
  width: 100%;
`;
const StyledButton = styled(Button) `
  flex: 1;
  height: 88px;
  font-size: 32px;
`;
